export const teamsChatPaneHeaderText = "WGzcVb";
export default {teamsChatPaneHeaderText};